import '@styles/app.css';
import main from '@commons/main';
import header from '@commons/header';
import PeopleIndex from '@vue-instances/PeopleIndex';

export default function init() {
  // Commons
  header();
  main();

  // Vue instances
  PeopleIndex();
}

init();
